import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const BaseAllergySeverityHl7Schema = z.object({
  severity_id: uuidSchema,
  hl7_code: z.string().max(20),
  display_name: z.string().max(100),
  description: z.string().nullable().optional(),
  fhir_criticality: z.string().max(20).nullable().optional(),
  alert_level: z.enum(['INFO', 'WARNING', 'BLOCKING']),
  display_order: z.number().int().nullable().optional(),
  created_at: z.string(),
});

export type BaseAllergySeverityHl7 = z.infer<typeof BaseAllergySeverityHl7Schema>;

/** Schema used to parse raw Prisma rows (Date -> ISO string) before returning */
export const AllergySeverityHl7ResponseSchema = BaseAllergySeverityHl7Schema.extend({
  created_at: z.coerce.date().transform((d) => d.toISOString()),
});

export type AllergySeverityHl7Response = z.infer<typeof AllergySeverityHl7ResponseSchema>;
